import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { IRootDispatch } from '../../../../store/models';

import DeprecatedSearchTileGrid from './DeprecatedSearchTileGrid';
import SearchTileGrid from './SearchTileGrid';
import {
  newMobileTiles,
  newDesktopTiles,
  newIPadTiles,
  tiles,
  tilesDesktopHomePage,
} from './SearchGridTiles';
import { ISearchTile } from '../SearchTile/SearchTile.types';
import { useResponsiveEffect } from '../../../../hooks';
import { SEARCH_ROUTE } from '../../../../route-names';
import { getWidth } from '../../../../modules/Responsive';
import { listenToWidth } from '../../../../modules/Responsive/listenToWidth';
import { TilesSizes, TilesSizesMap } from './constants';
import store from '../../../../store';

export default function SearchTileGridContainer({
  params,
}) {
  const is = useResponsiveEffect();
  const dispatch = useDispatch<IRootDispatch>();
  const userSelector = store.select.user;
  const isLandingRedesignEnabled = useSelector(userSelector.inLandingRedesign2024);
  const [width, setWidth] = useState(getWidth);

  useEffect(() => {
    const handleResize = newHeight => setWidth(newHeight);
    return listenToWidth(handleResize);
  });

  const handleTileSearch = (tile: ISearchTile) => {
    dispatch.route.go({
      route: SEARCH_ROUTE,
      params: {
        ...tile.searchParams,
        ...params,
        source: 'search_tiles',
      },
      notify: true,
    });
  };

  const splitTiles = (searchTiles: ISearchTile[], tilesColumns: number) => {
    const result = [];
    for (let i = 0; i < searchTiles.length; i += tilesColumns) {
      result.push(searchTiles.slice(i, i + tilesColumns));
    }
    return result;
  };

  if (isLandingRedesignEnabled) {
    let sizesMap = TilesSizesMap[TilesSizes.Desktop];
    let searchTiles = newDesktopTiles;
    let tilesColumns = 6;
    if (width <= 400) {
      sizesMap = TilesSizesMap[TilesSizes.Phone];
      searchTiles = newMobileTiles;
      tilesColumns = 3;
    } else if (width <= 470) {
      sizesMap = TilesSizesMap[TilesSizes.PhoneLarge];
      searchTiles = newMobileTiles;
      tilesColumns = 3;
    } else if (width <= 550) {
      sizesMap = TilesSizesMap[TilesSizes.PhoneExtraLarge];
      searchTiles = newMobileTiles;
      tilesColumns = 3;
    } else if (width <= 670) {
      sizesMap = TilesSizesMap[TilesSizes.TabletSmall];
      searchTiles = newIPadTiles;
      tilesColumns = 5;
    } else if (width <= 770) {
      sizesMap = TilesSizesMap[TilesSizes.TabletNarrow];
      searchTiles = newIPadTiles;
      tilesColumns = 5;
    } else if (width <= 1024) {
      sizesMap = TilesSizesMap[TilesSizes.Tablet];
      searchTiles = newIPadTiles;
      tilesColumns = 5;
    }
    const splittedTiles = splitTiles(searchTiles, tilesColumns);
    return (
      <SearchTileGrid
        tiles={splittedTiles}
        isMobile={width <= 430}
        imageHeight={sizesMap.imageHeight}
        imageWidth={sizesMap.imageWidth}
        space={sizesMap.space}
        setBackground={width <= 736}
        onSelectTile={handleTileSearch}
      />
    );
  }

  return (
    <DeprecatedSearchTileGrid
      tiles={(is.mobile || is.tablet) ? tiles : tilesDesktopHomePage}
      onSelectTile={handleTileSearch}
    />
  );
}
